var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Loading from "@irati/ui/src/Loading";
import History from "@irati/utils/history";
import { injectIntl } from "@irati/utils/lang";
import ErrorText from "@irati/ui/src/ErrorText";
import getMessage from "@irati/utils/lang/helpers/getMessage";
import tracking from "@irati-tracking/perks/perks";
import basket from "@irati/checkout/utils/basket";
import authentication from "@irati/auth";
import redemptionUtils from "../../helpers/redemption/redemptionUtils";
import DealSEO from "../../components/DealSEO";
import Email from "../../components/ProductForms/Email";
import ProductLayout from "../../components/ProductForms/ProductLayout";
import OnLeaveRedemption from "../../containers/OnLeaveRedemption/OnLeaveRedemption";
import ErrorNotification from "../../components/ErrorNotification";
import SagaSteps from "../../constants/sagaSteps";
var RedeemEmail = /** @class */ (function (_super) {
    __extends(RedeemEmail, _super);
    function RedeemEmail(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEmailChange = function (email) { return _this.setState({ email: email }); };
        _this.handleError = function (err) {
            _this.setState({ error: redemptionUtils.handleSagaErrors(err), block: false, submit: null });
        };
        _this.onContinue = function () {
            var details = {
                email: _this.state.email
            };
            var _a = _this.state, deal = _a.deal, saga = _a.saga;
            tracking.redeemPerkSagaStatus(deal, saga);
            var submit = redemptionUtils
                .nextStep(saga, deal, details)
                .then(function (updatedSaga) {
                _this.setState({ block: false });
                return updatedSaga;
            })
                .then(function (updatedSaga) {
                var nextStep = redemptionUtils.currentStep(updatedSaga, deal);
                History.replace({
                    pathname: nextStep,
                    state: {
                        deal: deal,
                        saga: updatedSaga
                    }
                }, _this.context);
            })
                .catch(_this.handleError);
            _this.setState({ submit: submit });
        };
        var location = props.location;
        var deal = get(location, "state.deal", {});
        _this.state = {
            deal: deal,
            saga: get(props, "location.state.saga", null),
            email: authentication.user().email,
            block: true
        };
        return _this;
    }
    RedeemEmail.prototype.UNSAFE_componentWillMount = function () {
        var _this = this;
        /**
         * Get latest saga - check step / check for basket
         */
        var sagaUuid = get(this.props, "match.params.sagaUuid", null);
        var load = redemptionUtils
            .handleIncorrectStep(sagaUuid)
            .then(function (saga) {
            if (saga.nextStep !== SagaSteps.UPDATE || basket.items.length === 0) {
                _this.setState({
                    deal: saga.deal
                });
                throw new Error(_this.props.formatMessage({ id: "perks.containers.redeemProduct.redeemDetails.error.unableToContinue" }));
            }
            else {
                _this.setState({ saga: saga, deal: saga.deal });
            }
        })
            .catch(this.handleError);
        this.setState({ load: load });
    };
    RedeemEmail.prototype.render = function () {
        var _a = this.state, email = _a.email, deal = _a.deal, submit = _a.submit, load = _a.load, error = _a.error, block = _a.block;
        var formatMessage = this.props.formatMessage;
        var disabled = !email || error;
        return (React.createElement(Loading, { load: load },
            React.createElement(DealSEO, { deal: deal, pageTitle: this.props.formatMessage({ id: "perks.containers.redeemProduct.redeemDetails.dealSEO.pagetitle" }) }),
            React.createElement(OnLeaveRedemption, { block: block }),
            React.createElement(ProductLayout, { onClick: this.onContinue, email: email, deal: deal, disabled: disabled, loading: submit },
                error && (React.createElement(ErrorNotification, null,
                    React.createElement(ErrorText, null, getMessage(formatMessage, error.message, error.errorData)))),
                !error && React.createElement(Email, { email: email, onChange: this.handleEmailChange }))));
    };
    RedeemEmail.contextTypes = {
        // required for history redirect
        appPath: PropTypes.string.isRequired
    };
    return RedeemEmail;
}(Component));
export default injectIntl(RedeemEmail);
